const CommonElementSizeMap = {
    sm: "32px",
    md: "48px",
    lg: "64px",
    auto: undefined,
};

export { CommonElementSizeMap };
//# sourceMappingURL=ui.js.map
